<main class="flex relative min-h-screen w-full flex-col bg-white">
  <app-floating-buttons
    class="fixed bottom-18 right-3 lg:bottom-6 lg:right-6 z-40 transition-opacity"
    [class.hidden]="isFloatingHiddenPage() && isMobileSize()" />

  <div class="mx-auto w-full flex-1 flex flex-col">
    <app-header (menuToggle)="toggleMenu()" />
    <div class="flex-1 pt-14 lg:pt-18 lg:pb-0" [class.pb-15]="!(isStickyHiddenPage() && isMobileSize())">
      <router-outlet />
    </div>

    <!-- 모바일 슬라이드 메뉴 -->
    @if (menuOpen()) {
    <div @slideInOut class="bg-white fixed top-0 z-50 h-screen w-full overflow-y-auto px-4 pb-20 lg:hidden">
      <div class="flex justify-between items-center py-3 pb-6">
        <a routerLink="/" (click)="toggleMenu()" class="cursor-pointer">
          <img
            [src]="logoData()?.value || '/logo.svg'"
            alt="마이스좋은공간 로고"
            class="bg-cover bg-center bg-no-repeat w-24" />
        </a>
        <button type="button" (click)="toggleMenu()" class="cursor-pointer text-zinc-400" aria-label="close menu">
          <app-icon name="material-symbols:close" class="size-6!" />
        </button>
      </div>

      <nav class="flex flex-col text-zinc-800">
        @for (item of navItems; track $index) {
        <a
          [routerLink]="[item.path]"
          (click)="toggleMenu()"
          class="flex justify-between items-center cursor-pointer py-4 border-b border-zinc-100">
          <span class="text-base font-semibold text-zinc-800">{{ item.label }}</span>
          <app-icon name="material-symbols:arrow-forward-ios-rounded" class="size-4! text-zinc-300" />
        </a>
        }

        <button
          class="cursor-pointer w-full flex items-center justify-between rounded-xl p-3 mt-6 bg-[#820D20] text-white shadow-custom"
          routerLink="/inquiry/form"
          (click)="toggleMenu()">
          <div class="flex gap-2 items-center">
            <app-icon name="mdi:square-edit-outline" class="size-5! text-white" />
            <p class="font-bold">제휴 문의</p>
          </div>
          <app-icon name="material-symbols:arrow-outward-rounded" class="size-5! text-white" />
        </button>

        <!-- 연계사이트 -->
        <div class="flex flex-col mt-8">
          <div class="flex items-center gap-2 pb-3">
            <span class="text-xs font-semibold text-zinc-400 uppercase tracking-widest">연계사이트</span>
            <div class="flex-1 h-px bg-zinc-100"></div>
          </div>
          @for (site of relatedSites; track $index) {
          <a
            [href]="site.url"
            target="_blank"
            rel="noopener noreferrer"
            (click)="toggleMenu()"
            class="flex justify-between items-center py-2.5">
            <span class="text-sm text-zinc-400 font-medium">{{ site.label }}</span>
            <app-icon name="material-symbols:arrow-forward-ios-rounded" class="size-3! text-zinc-200" />
          </a>
          }
        </div>
      </nav>
    </div>
    }
  </div>

  <!-- 모바일 하단 고정 스티키 버튼 -->
  <div
    class="fixed bottom-0 left-0 w-full z-40 lg:hidden"
    [class.hidden]="menuOpen() || (isStickyHiddenPage() && isMobileSize())">
    <a
      routerLink="/inquiry"
      class="bg-[#820D20] flex items-center justify-center gap-2 w-full h-15 cursor-pointer shadow-[0_-4px_10px_rgba(0,0,0,0.1)]">
      <app-icon name="mdi:square-edit-outline" class="size-6! text-white" />
      <span class="font-bold text-lg text-white">제휴문의하러 가기</span>
    </a>
  </div>

  <div class="lg:pb-0" [class.pb-15]="!(isStickyHiddenPage() && isMobileSize())">
    <app-footer />
  </div>
</main>
